import { i18n } from '@/plugins/i18n'


export default [
    {
        field: 'id',
        width: 90,
        title: i18n.t('label.accounting_account_id'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'account_number',
        width: 100,
        title: i18n.t('label.accounting_account_number'),
        sortable: false,
        textAlign: 'center',
    },
    // sheba number
    // {
    //     field: 'account_number',
    //     width: 90,
    //     title: i18n.t('label.accounting_account_number'),
    //     sortable: false,
    //     textAlign: 'center',
    // },
    // {
    //     field: 'company',
    //     width: 90,
    //     title: i18n.t('label.accounting_company_id'),
    //     sortable: false,
    //     textAlign: 'center',
    // },
    {
        field: 'iban',
        width: 200,
        title: i18n.t('label.accounting_iban_number'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'bank_name',
        width: 90,
        title: i18n.t('label.accounting_bank_name'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.date'),
        sortable: true,
        textAlign: 'center',
    }
]